module.exports = "https://deal-img.imgix.net/consumer/modern/notification-denied.590ad10b.png";